module.exports = __webpack_public_path__ + "img/Watching.a0d90532.svg";